import firebase from 'firebase'; // TODO-AUDIT: replace by "import firebase from 'firebase/app'"

import { firebaseConfig } from './config';

type Config = Parameters<typeof firebase.initializeApp>[0];

export class Fuego {
  public db: ReturnType<firebase.app.App['firestore']>;
  public auth: typeof firebase.auth;
  public functions: typeof firebase.functions;
  public storage: typeof firebase.storage;
  public database: typeof firebase.database;
  public firestore: typeof firebase.firestore;
  constructor(config: Config) {
    this.db = !firebase.apps.length
      ? firebase.initializeApp(config).firestore()
      : firebase.app().firestore();
    this.auth = firebase.auth;
    this.functions = firebase.functions;
    this.storage = firebase.storage;
    this.database = firebase.database;
    this.firestore = firebase.firestore;
  }
}

export const fuego = new Fuego(firebaseConfig);
